import { render, staticRenderFns } from "./KnowOriM.vue?vue&type=template&id=5c21087a&scoped=true&"
import script from "./KnowOriM.vue?vue&type=script&lang=js&"
export * from "./KnowOriM.vue?vue&type=script&lang=js&"
import style0 from "./KnowOriM.vue?vue&type=style&index=0&id=5c21087a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21087a",
  null
  
)

export default component.exports